<template>
    <div v-if="dados_tabela_frete.tabfrevig_id">
    <div class="loadingDataPosition">
        <div class="loadingData" v-if="isLoadingDadosTabela"><div class="loadingDataSpinner"><spinner v-if="isLoadingDadosTabela" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
            <b-modal id="modal_detalhestabela"
                     ref="modal_detalhestabela"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     :ok-disabled=form.errors.any()
                      v-model="showModal"
                     @ok="showModal">
       <div class="container-fluid">
            <div class="row">
                 <div class="col-xl-12 col-md-12 col-12">
                     <div class="card">
                      <!-- project-info -->
                      <div id="project-info" class="card-body row">
                          <div class="project-info-count col-lg-3 col-md-3">
                              <div class="project-info-icon">
                                 <h2>{{dados_tabela_frete.tabela_frete.cd}} - {{dados_tabela_frete.tabela_frete.descr}}</h2>
                              </div>
                             <div class="project-info-text pt-1">
                                <h5>Vigência: {{this.formatDate(dados_tabela_frete.dt_vigencia_ini)}} até {{this.formatDate(dados_tabela_frete.dt_vigencia_fim)}}</h5>
                             </div>
                             <div class="project-info-text pt-1">
                                 <span class="badge badge-success" v-if="dados_tabela_frete.tabela_frete.tp_tabela.valor==1">{{ dados_tabela_frete.tabela_frete.tp_tabela.descr }}</span>
                                 <span class="badge badge-warning" v-if="dados_tabela_frete.tabela_frete.tp_tabela.valor==2">{{ dados_tabela_frete.tabela_frete.tp_tabela.descr }}</span>
                                 <span class="badge badge-warning" v-if="dados_tabela_frete.status.valor==1">{{ dados_tabela_frete.status.descr }}</span>
                                 <span v-b-tooltip :title="'Aprovado por : '+dados_tabela_frete.usuario_aprov.pessoa.pessoa_fisica.nome" class="badge badge-success" v-if="dados_tabela_frete.status.valor==2">{{ dados_tabela_frete.status.descr }}</span>
                                 <span v-b-tooltip :title="'Cancelado por : '+dados_tabela_frete.usuario_canc.pessoa.pessoa_fisica.nome" class="badge badge-danger" v-if="dados_tabela_frete.status.valor==3">{{ dados_tabela_frete.status.descr }}</span>
                             </div>
                          </div>
                         <div class="project-info-count col-lg-2 col-md-2">
                             <div class="project-info-icon">
                                <h4>Origem</h4>
                             </div>
                            <div v-for="item in dados_tabela_frete.tabela_frete_vigencia_origem" class="project-info-text pt-1">
                               <h5>{{item.regiao.descr}}</h5>
                            </div>
                         </div>
                         <div class="project-info-count col-lg-2 col-md-2">
                             <div class="project-info-icon">
                                <h4>Destino</h4>
                             </div>
                            <div v-for="item in dados_tabela_frete.tabela_frete_vigencia_destino" class="project-info-text pt-1">
                               <h5>{{item.regiao.descr}}</h5>
                            </div>
                         </div>
                         <div class="project-info-count col-lg-2 col-md-2">
                             <div class="project-info-icon">
                                <h4>Unidade(s)</h4>
                             </div>
                            <div v-for="item in dados_tabela_frete.tabela_frete_vigencia_unidade" class="project-info-text pt-1">
                               <h5>{{item.unidade.descr}}</h5>
                            </div>
                         </div>
                         <div class="project-info-count col-lg-3 col-md-3">
                             <div class="project-info-icon">
                                <h4>Valores</h4>
                             </div>
                            <div class="project-info-text pt-1">
                               <h6>Vlr. total frete = R$ {{this.formatNumber(this.retorno_valores.valor_frete)}}</h6>
                            </div>
                            <div class="project-info-text pt-1">
                               <h6>Vlr. total NFe = R$ {{this.formatNumber(this.retorno_valores.vlr_total_nfe)}}</h6>
                            </div>
                            <div class="project-info-text pt-1">
                               <h6>Peso = KG: {{this.formatNumber(this.retorno_valores.peso_carga)}}</h6>
                            </div>
                         </div>
                      </div>
                     </div>
                 </div>
            </div>
        </div>
                    <div class="container-fluid">
                        <div class="row">
                             <div class="col-xl-12 col-md-12 col-12">
                                 <div class="row">
                                     <div class="col-md-4 col-sm-4">
                                         <div class="card border-top-primary">
                                             <div class="pb-0 card-header">
                                                 <h4 class="card-title">Taxas</h4>
                                                 <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                                 <div class="heading-elements">
                                                 </div>
                                             </div>
                                             <div class="pt-0 card-content collapse show">
                                                 <div class="card-body">
                                                     <table class="table mb-0">
                                                       <thead>
                                                         <tr>
                                                           <th>Tipo</th>
                                                           <th>Taxa</th>
                                                           <th>Valor</th>
                                                         </tr>
                                                       </thead>
                                                       <tbody>
                                                         <tr>
                                                           <td>Taxa GRIS</td>
                                                           <td>{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_gris)}} %</td>
                                                           <td>R$: {{retorno_valores.taxa_gris}}</td>
                                                         </tr>
                                                         <tr>
                                                           <td>Taxa Devolução</td>
                                                           <td>{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_devolucao)}} %</td>
                                                           <td>R$:</td>
                                                         </tr>
                                                         <tr>
                                                           <td>Taxa Reentrega</td>
                                                           <td>{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_reentrega)}} %</td>
                                                           <td>R$:</td>
                                                         </tr>
                                                       </tbody>
                                                     </table>
                                                 </div>
                                             </div>
                                         </div>
                                      </div>
                                      <div class="col-md-5 col-sm-5">
                                         <div class="card border-top-primary">
                                             <div class="pb-0 card-header">
                                                 <h4 class="card-title">Taxas</h4>
                                                 <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                                 <div class="heading-elements">
                                                 </div>
                                             </div>
                                             <div class="pt-0 card-content collapse show">
                                                 <div class="card-body">
                                                     <table class="table mb-0">
                                                       <thead>
                                                         <tr>
                                                           <th></th>
                                                           <th>Tipo</th>
                                                           <th>Taxa</th>
                                                           <th>Valor NF</th>
                                                           <th>Valor Final</th>
                                                         </tr>
                                                       </thead>
                                                       <tbody>
                                                           <tr>
                                                               <td>
                                                                   <span class="badge badge-success">TDE</span>
                                                               </td>
                                                             <td>
                                                                 {{dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tde.descr}}
                                                             </td>
                                                             <td>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tde.valor==2">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_tde)}} %</span>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tde.valor==3">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_tde)}} %</span>
                                                             </td>
                                                             <td>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tde.valor==4">R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_fixo_tde)}}</span>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tde.valor==3">R$: {{this.formatNumber(this.retorno_valores.vlr_total_nfe)}}</span>
                                                             </td>
                                                             <td>
                                                                 R$: {{this.formatNumber(this.retorno_valores.taxa_tde)}}
                                                             </td>
                                                           </tr>
                                                           <tr>
                                                               <td>
                                                                   <span class="badge badge-secondary">TDA</span>
                                                               </td>
                                                             <td>
                                                                 {{dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tda.descr}}
                                                             </td>
                                                             <td>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tda.valor==2">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_tda)}} %</span>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tda.valor==3">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_tda)}} %</span>
                                                             </td>
                                                             <td>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tda.valor==4">R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_fixo_tda)}}</span>
                                                                 <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_tda.valor==3">R$: {{this.formatNumber(this.retorno_valores.vlr_total_nfe)}}</span>
                                                             </td>
                                                             <td>
                                                                 R$: {{this.formatNumber(this.retorno_valores.taxa_tda)}}
                                                             </td>
                                                           </tr>
                                                         <tr>
                                                             <td>
                                                                 <span class="badge badge-primary">Pedágio</span>
                                                             </td>
                                                           <td>
                                                               {{dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_pedagio.descr}}
                                                           </td>
                                                           <td>
                                                               <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_pedagio.valor==2">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_pedagio)}} %</span>
                                                               <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_pedagio.valor==3">{{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.taxa_pedagio)}} %</span>
                                                           </td>
                                                           <td>
                                                               <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_pedagio.valor==4">R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_pedagio)}}</span>
                                                               <span v-if="dados_tabela_frete.tabela_frete_vigencia_taxa.tp_taxa_pedagio.valor==3">R$: {{this.formatNumber(this.retorno_valores.vlr_total_nfe)}}</span>
                                                           </td>
                                                           <td>
                                                               R$: {{this.formatNumber(this.retorno_valores.taxa_pedagio)}}
                                                           </td>
                                                         </tr>
                                                       </tbody>
                                                     </table>
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                     <div class="col-md-3 col-sm-3">
                                    <div class="card border-top-primary">
                                        <div class="pb-0 card-header">
                                            <h4 class="card-title">Valores</h4>
                                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                            <div class="heading-elements">
                                            </div>
                                        </div>
                                        <div class="pt-0 card-content collapse show">
                                            <div class="card-body">
                                                <table class="table mb-0">
                                                  <thead>
                                                    <tr>
                                                      <th>Tipo</th>
                                                      <th>Valor</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <td>Valor TAS</td>
                                                      <td>R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_tas)}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>Valor Despacho</td>
                                                      <td>R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_despacho)}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>Valor sec.</td>
                                                      <td>R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_sec_cat)}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>Valor Agendamento</td>
                                                      <td>R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_agendamento)}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>Valor outros</td>
                                                      <td>R$: {{this.formatNumber(dados_tabela_frete.tabela_frete_vigencia_taxa.vlr_outros)}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                  <div class="card border-top-primary">
                                      <div class="pb-0 card-header">
                                          <h4 class="card-title">Faixa de Peso - KG {{formatNumber(dados_tabela_frete.valores.peso_carga)}}</h4>
                                          <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                          <div class="heading-elements">
                                          </div>
                                      </div>
                                      <div class="pt-0 card-content collapse show">
                                          <div class="card-body">
                                              <table class="table mb-0">
                                                <thead>
                                                  <tr>
                                                    <th>Tipo</th>
                                                    <th>Tipo Peso</th>
                                                    <th>Peso Inicial</th>
                                                    <th>Peso Final</th>
                                                    <th>Valor</th>
                                                    <th>Status</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr :class="classSelecionado(item)" v-for="item in dados_tabela_frete.tabela_frete_vigencia_frete_peso">
                                                    <td>
                                                        {{item.tp_faixa.descr}}
                                                    </td>
                                                    <td>
                                                        {{item.tp_peso.descr}}
                                                    </td>
                                                    <td>
                                                        {{formatNumber(item.peso_ini)}}
                                                    </td>
                                                    <td>
                                                        {{formatNumber(item.peso_fim)}}
                                                    </td>
                                                    <td>
                                                        R$: {{formatNumber(item.vlr)}}
                                                    </td>
                                                    <td>
                                                        {{item.status.descr}}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="card border-top-primary">
                                    <div class="pb-0 card-header">
                                        <h4 class="card-title">Faixa de Valor - KM : {{formatNumber(dados_tabela_frete.valores.vn_distancia_trecho)}}</h4>
                                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                        <div class="heading-elements">
                                        </div>
                                    </div>
                                    <div class="pt-0 card-content collapse show">
                                        <div class="card-body">
                                            <table class="table mb-0">
                                              <thead>
                                                <tr>
                                                  <th>Tipo</th>
                                                  <th>KM Inicial</th>
                                                  <th>KM Final</th>
                                                  <th>Valor</th>
                                                  <th>Status</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr :class="classSelecionado(item)" v-for="item in dados_tabela_frete.tabela_frete_vigencia_frete_valor">
                                                  <td>
                                                      {{item.tp_faixa.descr}}
                                                  </td>
                                                  <td>
                                                      {{formatNumber(item.km_ini)}}
                                                  </td>
                                                  <td>
                                                      {{formatNumber(item.km_fim)}}
                                                  </td>
                                                  <td>
                                                      R$: {{formatNumber(item.taxa)}}
                                                  </td>
                                                  <td>
                                                      {{item.status.descr}}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                                  <div class="row">
                                      <div class="col-md-6 col-sm-6">
                            			<div class="card border-top-primary">
                            				<div class="pb-0 card-header">
                            					<h4 class="card-title">Veículo(s)</h4>
                            					<a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                    			<div class="heading-elements">
                            					</div>
                            				</div>
                            				<div class="pt-0 card-content collapse show">
                            					<div class="card-body">
                            						<span v-for="item in dados_tabela_frete.tabela_frete_vigencia_veiculo">
                                                        <p>
                                                            {{item.param_tipo_rodado.descr}}
                                                            <span v-if="item.refrigerado.valor==1"> - Refrigerado - </span>
                                                            <span v-if="item.refrigerado.valor==2"> - Não Refrigerado - </span>
                                                            <span v-if="item.carga_perigosa.valor==1">Carga Perigosa</span>
                                                            <span v-if="item.carga_perigosa.valor==2">Carga não perigosa</span>
                                                        </p>
                                                        <hr>
                                                    </span>
                            					</div>
                            				</div>
                            			</div>
                            		</div>
                                    <div class="col-md-6 col-sm-6">
                                      <div class="card border-top-primary">
                                          <div class="pb-0 card-header">
                                              <h4 class="card-title">Carga(s)</h4>
                                              <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                              <div class="heading-elements">
                                              </div>
                                          </div>
                                          <div class="pt-0 card-content collapse show">
                                              <div class="card-body">
                                                  <span v-for="item in dados_tabela_frete.tabela_frete_vigencia_carga">
                                                      <p>
                                                          {{item.param_tipo_carga.descr}} - {{item.tp_carga.descr}}
                                                      </p>
                                                      <hr>
                                                  </span>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6 col-sm-6">
                                  <div class="card border-top-primary">
                                      <div class="pb-0 card-header">
                                          <h4 class="card-title">Cliente(s)</h4>
                                          <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                                          <div class="heading-elements">
                                          </div>
                                      </div>
                                      <div class="pt-0 card-content collapse show">
                                          <div class="card-body">
                                              <span v-for="item in dados_tabela_frete.tabela_frete_vigencia_pessoa">
                                                  <p>
                                                      <span v-if="item.pessoa.pessoa_fisica!==null">{{item.pessoa.pessoa_fisica.nome}} - {{item.pessoa.pessoa_fisica.cpf}}</span>
                                                      <span v-if="item.pessoa.pessoa_juridica!==null">{{item.pessoa.pessoa_juridica.razao_social}} - CNPJ: {{onFormataCnpj(item.pessoa.pessoa_juridica.cnpj_base,item.pessoa.pessoa_juridica.cnpj_filial,item.pessoa.pessoa_juridica.cnpj_digito)}} - IE: {{item.pessoa.pessoa_juridica.inscricao_estadual}}</span>
                                                      <span v-if="item.pessoa.pessoa_exterior!==null">{{item.pessoa.pessoa_exterior.nome}} - {{item.pessoa.pessoa_exterior.cd}}</span>
                                                  </p>
                                              </span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                             </div>
                     </div>
                </div>
                        <div slot="modal-footer" class="w-100">
                            <div class="float-left">
                                <spinner v-if="loading" message="Processando..."></spinner>
                            </div>
                            <div class="float-right">
                                <b-btn @click="onVoltar()" variant="secondary">
                                  Voltar
                                </b-btn>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'

export default {
    components: {
        VMoney,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingDataServicos: true,
          showPopover: false,
          showModal: false,
          isLoadingDadosTabela: false,
          dados_tabela_frete: {},
          retorno_valores: {},
          servicos: [],
          errors_array: [],
          tabfrevig_id: '',
          form: new Form({
                    tabfrevig_id: ''
                }),
         helpForm: new Form({tabfrevig_id: '', tp_busca_tabela: '', valores: '',}),
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
    },
    mounted() {
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingDataServicos = false;
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatDate (value, fmt = 'DD/MM/YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        classSelecionado : function(item){
            if(item.selecionado==1)
            {
                return 'table-success';
            }
            else
            {
                return;
            }
        },
        onBuscaTabela (tabfrevig_id, valores) {console.log(valores);console.log(1);
            this.isLoadingDadosTabela = true;
            this.modal_titulo = "Detalhes da Tabela";
            this.modal_botao = "Selecionar";
            this.modal_acao = "i";
            this.helpForm.tabfrevig_id = tabfrevig_id;
            this.helpForm.tp_busca_tabela = 2;
            this.helpForm.valores = valores;

            //Busca os dados da tabela selecionada
            this.helpForm.post('/api/cotacao/tabelafrete').then(response => {console.log(response);
                    new ReturnApi(response, this, true, false, false);
                    this.dados_tabela_frete = response.tabela_frete[0];
                    this.dados_tabela_frete.tabfrevig_id       = response.tabela_frete[0].tabfrevig_id;
                    this.retorno_valores = response.tabela_frete[0].valores;
                    this.isLoadingTabelaFrete = false;
                })
                .catch(errors => {
                    new ReturnApi(errors, this)
                });
            this.isLoadingDadosTabela = false;
            this.showModal = true;
        },
        onStore() {
            this.servicos = null;
            this.servicos = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.$refs.vuetable.tableData.forEach((obj2)=>{
                    if(obj2.rowselect_id==obj)
                    {
                        this.servicos.push({ id: obj2.tabproced_id,
                                            descr_servico: obj2.descr_servico,
                                            descr_procedimento: obj2.descr_procedimento,
                                            cd_procedimento: obj2.cd_procedimento,
                                            descr_unidade_padrao: obj2.descr_unidade_padrao,
                                            descr_autorizacao_obrig: obj2.descr_autorizacao_obrig,
                                            descr_status: obj2.descr_status,
                                            descr_servico: obj2.descr_servico,
                                            servico_id: obj2.servico_id,
                                            qtde: obj2.qtde,
                                            qtde_semanal: obj2.qtde_semanal,
                                            tabproced_id: obj2.tabproced_id,
                                            preco: this.formatNumber(obj2.preco),
                        })
                    }
                });
            });
            this.$refs.modal_detalhestabela.hide();
            this.$parent.onVincular(this.servicos);
        },
        onVoltar() {
            this.$refs.modal_detalhestabela.hide();
            this.$parent.onVoltarDetalhes(this.helpForm.valores);
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatNumberQtd (value) {
            return accounting.formatNumber(value, 3, '.', ',')
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
